import React from 'react';

import Pagination from "../Pagination/Pagination";
import Aux from '../../../hoc/Aux/Aux';

const tableFooter = (props) => {

    const currentStart = ((props.currentPage-1)*10)+1;
    let pageTo = (currentStart-1) + 10;

    if (pageTo > props.navigation.totalItems) {
        pageTo = props.navigation.totalItems;
    }

    let pagination = null;

    if (props.navigation.totalPage > 1) {
        pagination = (
            <Pagination {...props}/>
        );
    }
    const tableFooter = props.numberOfResult > 0 ? (
        <Aux>
            <div className='col-sm-5' style={{marginTop: '30px'}}>
                Showing {currentStart} to {pageTo} of {props.navigation.totalItems} entries
            </div>
            <div className='col-sm-7 text-right'>
                {pagination}
            </div>
        </Aux>
    ) : ""

    return (
        <Aux>
            {tableFooter}
        </Aux>
    );

};

export default tableFooter;
